import { render } from "./VolumeSmallIcon.vue?vue&type=template&id=ea2eb7c4"
import script from "./VolumeSmallIcon.vue?vue&type=script&lang=js"
export * from "./VolumeSmallIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__